<div class="access-denied">
  <div class="text">
    <p>Для Вас доступ временно приостановлен.</p>
    <p>Попробуйте обратиться к Вашему системному администратору.</p>
    <p>И хорошего Вам дня (Администрация)</p>
    <button class="btn btn-blue" (click)="login()">ЛОГИН</button>
  </div>
</div>
